export default __webpack_public_path__ + "static/media/242.2682fdd6.jpg";